export const loadPage = (component, {url: link}, options) => {
  const loading = new Promise(function (resolve, reject) {
    component.$f7.mainView.router.load({url: link})
    resolve(link)
  })
  loading.then(function () {
    component.$bus.emit('nextLink', link)
  })
}

export const reloadPage = (component, {url: link}, options) => {
  if (link !== '') {
    const loading = new Promise(function (resolve, reject) {
      component.$f7.mainView.allowPageChange = true
      component.$f7.mainView.router.load({url: link})
      resolve(link)
    })
    loading.then(function () {
      component.$bus.emit('nextLink', link)
    })
  }
}

/* @author TLV 24/09/2020
* @brief redirection qui recharge le component si on est actuellement dessus */
export const reloadPage2 = (component, link) => {
  const loading = new Promise(function (resolve, reject) {
    component.$f7.mainView.allowPageChange = true
    component.$f7.mainView.router.load({url: link, reload: true})
    resolve(link)
  })
  loading.then(function () {
    component.$bus.emit('nextLink', link)
  })
}

export const pageBack = (component) => {
  if (component) {
    component.$f7.views.main.router.back()
  }
}

/* @author ATL
* @brief Navigate to a page and clear all history - useful after login/logout */
export const loadPageClearHistory = (component, {url: link}, options) => {
  const loading = new Promise(function (resolve, reject) {
    // First remove all pages from DOM except current
    component.$$('.page-on-left, .navbar-on-left, .page-previous, .navbar-previous').remove()
    
    // Clear the history
    component.$f7.mainView.history = []
    
    // Clear content cache if exists
    if (component.$f7.mainView.contentCache) {
      component.$f7.mainView.contentCache = {}
    }
    
    // Load the new page
    component.$f7.mainView.router.load({
      url: link,
      ignoreCache: true,
      reload: true
    })
    
    resolve(link)
  })
  
  loading.then(function () {
    component.$bus.emit('nextLink', link)
  })
}
